<template>
  <div>
    <Navbar/>

    <div class="contents">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar'

export default {
  components: {
    Navbar,
  }
}
</script>

<style scoped>
.contents {
  padding: 10px;
}
</style>
